module.exports = __webpack_public_path__ + "img/center front length to underbust.2d949ff4.png";